// extracted by mini-css-extract-plugin
module.exports = {"Day":"ActivitiesTab_Day__v-E8x","ActiveDay":"ActivitiesTab_ActiveDay__34Tkk","ProgressValue":"ActivitiesTab_ProgressValue__3GQ8B"};